import type React from "react";
import { Login } from "./Login.tsx";

export const ExternalLogin: React.FC = () => (
  <Login action="/login/external" type="external" />
);
